export const posts = [
    {
        title: 'TypeScript Just Stopped Being Written in TypeScript',
        desc: 'Microsoft rewrote its compiler in Go, made it 10x faster, and quietly answered the question everyone keeps asking. Is JavaScript dead?',
        img: 'https://miro.medium.com/v2/resize:fit:720/format:webp/1*8fxQo1_ePsN-b8tIe-BXKg.jpeg',
        url: 'https://medium.com/@ayushk3609/typescript-just-stopped-being-written-in-typescript-b946f7f61761'
    },
    {
        title: 'Handling UX with EJS',
        desc: 'First of all, let’s start with a basic idea: What is EJS or a view engine? 🤔 When dealing with server-side development, we often need to generate dynamic HTML content. Instead of writing HTML code manually for every possible outcome, we use a view engine to create templates that the server can fill with data on-the-fly. This is where EJS (Embedded JavaScript) comes into play. ✨',
        img: 'https://miro.medium.com/v2/resize:fit:720/format:webp/1*HgIQSfjkIwhJKVww_Tet8w.png',
        url: 'https://medium.com/@ayushk3609/use-of-view-engines-like-ejs-95c1e561c80b'
    },
    {
        title: 'Shopify Has No Plugins, and That Is Why It Is Winning',
        desc: 'The most restrictive ecommerce platform keeps beating the open ones. Here is the architecture behind that, and the proof in the numbers.',
        img: 'https://miro.medium.com/v2/resize:fit:720/format:webp/1*HnkswLfhzQ6NzySDb5ZdiA.png',
        url: 'https://medium.com/@ayushk3609/shopify-has-no-plugins-and-that-is-why-it-is-winning-23f7745e2938'
    },
]
